





























import { confirmDelete } from '@/libs/decorator';
import BasePageMixin from '@/mixins/base-page-mixin';
import CategoryServices, { CategoryDto } from '@/services/category';
import IndicatorSetServices, { IndicatorSetDto } from '@/services/indicatorSet';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import IndicatorSets from './indicator-sets.vue';

@Component({
  components: { IndicatorSets }
})
export default class Left extends mixins(BasePageMixin) {
  categorySrv = new CategoryServices();
  indSrv = new IndicatorSetServices();
  visible: boolean = false;
  folderId: any = 0;
  modalVisible: boolean = false;
  indSetId: number = 0;

  menu: any = [];
  async created() {
    this.getCategory();
  }

  // 获取目录
  async getCategory() {
    let list = await this.categorySrv.getList({ categoryType_eq: 5 });
    this.menu = list.map((cate: CategoryDto) => ({
      title: cate.categoryName,
      icon: cate.icon,
      type: 'folder',
      record: cate,
      oprate: [
        { name: '新建指标集', icon: 'fa-plus-circle', permissionKey: 'IND_SET_ADD', key: `add` },
        { name: '编辑目录', icon: 'fa-edit', key: `editFolder` },
        { name: '删除目录', icon: 'fa-trash', key: `removeFolder` }
      ],
      expand: false,
      id: cate.id,
      children: []
    }));
  }

  // 获取目录下文件
  async openFolderById(id: number) {
    let index = this.menu.findIndex((v: any) => v.id == id);
    this.menu[index].loading = true;
    let list = await this.indSrv.getList({ indSetCategoryId_eq: id });
    let plist: object[] = [];
    list.forEach((ind: IndicatorSetDto) => {
      plist.push({
        title: ind.indSetName,
        key: `/decision/indicator?indSetId=${ind.id}&indSetCode=${ind.indSetCode}`,
        icon: 'fa-cube',
        id: ind.id,
        record: ind,
        oprate: [
          { name: '编辑', icon: 'fa-edit', permissionKey: 'IND_SET_UPD', key: 'edit' },
          { name: '删除', icon: 'fa-trash', permissionKey: 'IND_SET_DEL', key: 'remove' }
        ]
      });
    });
    this.menu[index].children = plist;
    this.menu[index].expand = true;
    this.menu[index].loading = false;
  }

  command(key: string, record: any) {
    switch (key) {
      case 'add': // 新建
        this.indSetId = 0;
        this.folderId = record.id;
        this.modalVisible = true;
        break;
      case 'edit': // 编辑
        this.indSetId = record.id;
        this.modalVisible = true;
        break;
      case 'remove': // 删除
        this.removeIndSet(record.id);
        break;
      case 'addFolder': // 新建目录
        this.folderId = 0;
        this.visible = true;
        break;
      case 'editFolder': // 编辑目录
        this.folderId = record.id;
        this.visible = true;
        break;
      case 'removeFolder': // 删除目录
        this.removeFolder(record.id);
        break;
      case 'expandFolder': // 展开目录
        this.openFolderById(record.id);
        break;
      case 'link':
        this.$router.push(record);
        break;
      case 'refresh':
        this.reloadMenu();
      default:
        break;
    }
  }

  async removeFolder(id: number) {
    let res = await this.categorySrv.remove(id);
    if (!res) return false;
    this.$message.success('操作成功');
    this.reloadMenu();
  }

  @confirmDelete()
  async removeIndSet(id: string) {
    let res = await this.indSrv.remove(id);
    if (!res) return false;
    this.$message.success('操作成功');
    this.reloadMenu();
  }

  addIndSet(key: string) {
    this.indSetId = 0;
    let folderId = key.replace('action:addIndSet/', '');
    this.folderId = parseInt(folderId);
    this.modalVisible = true;
  }

  editIndSet(key: string) {
    this.indSetId = parseInt(key.replace('action:editIndSet/', ''));
    this.modalVisible = true;
  }

  // 重新载入目录下文件
  reloadMenu() {
    // 重新载入目录下文件
    let openFolderIds: number[] = [];
    this.menu.forEach((v: any, index: number) => {
      if (v.expand) {
        openFolderIds.push(v.id);
      }
    });
    this.getCategory();
    openFolderIds.forEach(id => this.openFolderById(id));
  }
}
